// Roles and permissions — spec §10.1 (R10.1, R10.2). Roles are named sets of permissions;
// permissions attach to actions. Instances may define further roles as combinations, never
// new permissions. Roles are scoped per site in the user record; a role without a site
// applies to every site of the tenant.
import { z } from "zod";
export const PERMISSIONS = [
    "flows.run", // run task flows on a device (receive, put away, move, count)
    "stock.read", // stock by location, container history, trace
    "deviations.handle", // mark deviations handled, confirm tally differences
    "deliveries.close", // delivery close
    "adjustments.approve", // approve counts/adjustments above the threshold
    "lots.status", // hold, release, block lots
    "reference.import", // import documents, registry edits
    "config.edit", // profiles, flows, site settings, reason codes
    "users.manage", // users, roles, login methods
    "devices.manage", // enrol devices, printers
    "events.read", // raw ledger reads and exports
];
export const Permission = z.enum(PERMISSIONS);
export const ROLES = ["operator", "lead", "quality", "administrator", "readonly", "integrator"];
export const Role = z.enum(ROLES);
export const ROLE_PERMISSIONS = {
    operator: ["flows.run", "stock.read"],
    lead: ["flows.run", "stock.read", "deviations.handle", "deliveries.close", "adjustments.approve", "events.read"],
    quality: ["stock.read", "lots.status", "deviations.handle", "events.read"],
    administrator: [...PERMISSIONS],
    readonly: ["stock.read", "events.read"],
    integrator: ["reference.import", "events.read", "stock.read"],
};
/** A role held by a user, optionally limited to one site. */
export const RoleGrant = z.object({ role: Role, siteId: z.string().nullable().default(null) });
/** The resolved permissions of a user for a site (R10.2: displayable). */
export function permissionsFor(grants, siteId = null) {
    const out = new Set();
    for (const g of grants) {
        if (g.siteId !== null && siteId !== null && g.siteId !== siteId)
            continue;
        for (const p of ROLE_PERMISSIONS[g.role])
            out.add(p);
    }
    return out;
}
//# sourceMappingURL=roles.js.map